import { api } from '@api/api';
import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

export type UserData = {
  name?: string;
  isBeremaUser: boolean;
  isDealerUser: boolean;
  isServiceUser: boolean;
  isOEMUser: boolean;
  isAuthenticated: boolean;
  customerNo: string | null;
  organizationId: string | null;
  email: string;
};
export interface UserState {
  isAuthenticated: boolean;
  name?: string | null;
  isBeremaUser?: boolean;
  isDealerUser?: boolean;
  isServiceUser: boolean;
  isOEMUser: boolean;
  customerNo?: string | null;
  organizationId?: string | null;
  email?: string | null;
}

const initialState: UserState = {
  isAuthenticated: false,
  customerNo: null,
  email: null,
  isBeremaUser: false,
  isDealerUser: false,
  isServiceUser: false,
  isOEMUser: false,
  name: null,
  organizationId: null,
};

// REDUCERS
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserData>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.getUserProfile.matchFulfilled, (state, action) => {
      return { ...state, ...action?.payload?.data };
    });
    builder.addMatcher(api.endpoints.logout.matchFulfilled, (state, action) => {
      return { ...initialState };
    });
  },
});

// SELECTORS
export const getUser = createSelector(
  (state: RootState) => state.user,
  (user) => user
);

export default userSlice.reducer;
